import React, { Component } from 'react'
import './css/mobile.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'

import Banner1 from '../../assets/image/banner-hompage1.jpg'
import {Button,Collapse} from '@material-ui/core'
import insight1 from '../../assets/image/insight1.jpg'
import insight2 from '../../assets/image/insight2.jpg'
import insight3 from '../../assets/image/insight3.jpg'
import insight4 from '../../assets/image/insight4.jpg'

import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'
import Event4 from '../../assets/image/event4.jpg'

import chevron from '../../assets/image/chevron-down.svg'
import Chevron from '../../assets/image/chevron-right.svg'
import join from '../../assets/image/join.jpg'
import Event from '../../components/grid/event'
import Insight from '../../components/grid/insight'

import assesment from '../../assets/image/home-services/assesment.jpg'
import digital from '../../assets/image/home-services/digital.jpg'
import learning from '../../assets/image/home-services/learning.jpg'
import strategy from '../../assets/image/home-services/strategy.jpg'
import Banner from '../../components/tribe/tribe_banner'

import Chrpe from '../../assets/image/event/chrpe/chrpe-cover.jpg'
import Corpu from '../../assets/image/event/corpu/corpu_cover.jpg'
import Cptm from '../../assets/image/event/cptm/cptm_cover.jpg'
import Hr from '../../assets/image/event/hr_4.0/hr_cover.jpg'
import Hrbp from '../../assets/image/event/hrbp/hrbp_cover.jpg'
import Ram from '../../assets/image/event/ram/ram_cover.jpg'
import Rise from '../../assets/image/event/rise/rise_cover.jpg'
import {TRACKING_ID} from '../../service/base_url'
import ReactGA from 'react-ga';
import img1 from '../../assets/image/home-services/1.png'
import img2 from '../../assets/image/home-services/2.png'
import img3 from '../../assets/image/home-services/3.png'
import img4 from '../../assets/image/home-services/4.png'
import img5 from '../../assets/image/home-services/5.png'
import img6 from '../../assets/image/home-services/6.png'
let data_consulting=[
    {
        title:"Strategy",
        content:"We help our clients in developing and implementing their strategy in order to improve performance and achieve growth.",
        img:Event1,
        link:'/services/consulting/strategy'
    },
    {
        title:"Structure",
        content:"We help our clients in developing and implementing strategy-based organization structure that ensure their employees work effectively to achieve  …",
        img:Event2,
        link:'/services/consulting/structur'
    },
    {
        title:"Change Management  & Culture",
        content:"We help our clients in identifying their pressing change issues, prioritizing and executing the areas for improvement in order to shape the organization …",
        img:Event1,
        link:'/services/consulting/change'
    },
    {
        title:"System",
        content:"We help our clients in developing and improving their business process that will deliver values and satisfaction to customers.",
        img:Event2,
        link:'/services/consulting/system'
    },
    {
        title:"People",
        content:"We help our clients in developing and implementing people best practices methodology that will contribute to the company’s future growth and sustainability.",
        img:Event3,
        link:'/services/consulting/people'
    },
    {
        title:"IT Strategic  Solution",
        content:"We help our clients in developing and enhancing their performance management and business productivity systems in order to make informed decision … ",
        img:Event1,
        link:'/services/consulting/it'
    }
]
let data_learning=[
    {
        title:"In-house Workshops",
        content:"Hundreds of organizations have been using our high quality in-class workshops for their training and development needs, with topics ranging from leadership …",
        img:Event1,
        link:'/services/learning/inhouse'
    },
    {
        title:"Certification Programs",
        content:"Lutan Edukasi Certification and Premium Products are complete sets of workshops to equip your people perform more effectively in your organization. The …",
        img:Event2,
        link:'/services/learning/certification'

    },
    {
        title:"Corporate University Services",
        content:"Our Corporate University services provide a complete set of services to support your Corporate University, from planning, preparing, and …",
        img:Event1,
        link:'/services/learning/corporate'

    },
    {
        title:"Blended Learning",
        content:"Training should not be a one-time activity. To ensure its effectiveness, researches have shown that Pre-Training Activities and Post-Training …",
        img:Event2,
        link:'/services/learning/blendedlearning'

    },
]
let data_eventmanagement=[
    {
        title:"Mega Seminar, Public Seminar, & Workshop",
        content:"We help you define your objectives, actualize your vision, and become your partner in managing your competency enhancement event.",
        img:Event1,
        link:'/services/eventmanagement/megaseminar'
    },
    {
        title:"Customer & Family Gathering, Team Building",
        content:"Whether planning a grand event or intimate gathering, we will supervise from site selection, theme development, menu selection, invitations, registrations, and executions.",
        img:Event2,
        link:'/services/eventmanagement/customerbuilding'
    },
    {
        title:"Product Launches",
        content:"We save your time and provide creative ideas to introduce new products, customize unique solutions and manage all your event details.",
        img:Event1,
        link:'/services/eventmanagement/productlaunch'
    },
    {
        title:"Corporate Meeting & Conference",
        content:"Special events with creative concepts & various themes. We provide superior services with details to create first-class events for large and small groups.",
        img:Event2,
        link:'/services/eventmanagement/corporatemeeting'
    },
    {
        title:"Artist / Speaker Management & Entertainment",
        content:"We manage all your requirements for hosting conferences and seminars.",
        img:Event3,
        link:'/services/eventmanagement/artist'
    },
    {
        title:"Themed and Custom Event",
        content:"Our experienced team has expertise in the industry and our valued network can deliver professional services.",
        img:Event1,
        link:'/services/eventmanagement/themeevvent'
    }
]
let data_digitallearning=[
    {
        title:"E-learning Platform Implementation",
        content:"We support your success in implementing e-learning platform initiative in your organization. Using a robust Learning Management System …",
        img:Event1,
        link:'/services/digitallearning/platform'
    },
    {
        title:"Infographic Animation (Motion Graphic)",
        content:"Design your information in an attractive way and gain the attention of your audiences with a simple animated simulation to delivered your objective.",
        img:Event2,
        link:'/services/digitallearning/motiongraphic'
    },
    {
        title:"Mobile Learning",
        content:"We always adapt with the latest technology-based learning methodology to keep pace with the shifting learning styles of the millennials.",
        img:Event1,
        link:'/services/digitallearning/mobilelearning'
    },
    {
        title:"E-Learning Content Development",
        content:"We also help you in creating and converting your conventional content delivery into interactive digital learning delivery to ensure your millennials keep engaging …",
        img:Event2,
        link:'/services/digitallearning/content'
    },
    {
        title:"e-Game for Class Activity",
        content:"Bored with conventional classroom learning methods? We are here to help you to enrich your conventional classroom learning methods with digital …",
        img:Event3,
        link:'/services/digitallearning/game'
    },
    {
        title:"Technical In-house Workshops for e-Learning Administrator …",
        content:"We share our knowledge and years of experiences as an e-learning implementor and practices in various industry and corporate. We will prepare …",
        img:Event1,
        link:'/services/digitallearning/workshops'
    }
]
let data_assestment=[
    {
        title:"Virtual Assessment Center",
        content:"Simulates an online desktop environment, where Participants are presented with a variety of information and business issues.",
        img:Event1,
        link:'/services/assesment/virtualassestmment'
    },
    {
        title:"Psychological Test",
        content:"Psychological test is a set of items designed to measure characteristics of human beings that pertain behavior”.",
        img:Event2,
        link:'/services/assesment/psychologi'
    },
    {
        title:"Assessment Center",
        content:"Assessment Center is the method for assessing one’s competence through several behavioral simulations that refers to the competencies needed for …",
        img:Event1,
        link:'/services/assesment/center'
    },
    {
        title:"Online Psychological Test",
        content:"Talentlytica Psychograph Analytics is most determined to provide the services related to psychometric analytics best to fit your needs.",
        img:Event2,
        link:'/services/assesment/onlinetest'
    },
    {
        title:"Competency",
        content:"Build & Development of Competency Dictionary Competency is ability to be and the ability to interact with others follow by ability to know and … ",
        img:Event3,
        link:'/services/assesment/compentency'
    },
]
let data_digital_human=[
    {
        title:"World-Class Curriculum",
        content:"Curriculum designed and advised by the Father of Modern HR Science and world-class digital and HR Directors comprehensive academy from foundational, advanced to strategic digital and HR academy",
        img:img1,
        link:'/services/assesment/compentency'
    },
    {
        title:"Top  Facilitators",
        content:"Inspiring industrial practitioner  TOP speakers: HR and Digital Directors & Consultants",
        img:img2,
        link:'/services/assesment/compentency'
    },
    {
        title:"Experiential  Learning Method",
        content:"Leading-edge framework with  practical skills and tools (30% theory + 70%  sharing, tools and practices)",
        img:img3,
        link:'/services/assesment/compentency'
    },
    {
        title:"Accredited Certification",
        content:"SKKNI accredited certifications by BNSP, Global Principal Certification",
        img:img4,
        link:'/services/assesment/compentency'
    },
    {
        title:"Post-Workshop Coaching & Collaboration",
        content:"Blended learning approach combining online learning, offline discussions and post-workshop coaching Alumni forum, resource portal, and HR clinics for peer coaching & benchmark",
        img:img5,
        link:'/services/assesment/compentency'
    },
    {
        title:"Impact Building",
        content:"Alumni community contributing to  Corporate Social Responsibility (CSR) & nation building",
        img:img6,
        link:'/services/assesment/compentency'
    },
]
export default class mobile extends Component {
    state={
        collapse_consulting:false,
        collapse_event:false,
        collapse_assesment:false,
        collapse_learning:false,
        collapse_digital:false,
        collapse_digital_human:false,
        
    }
    componentDidMount(){
        // ReactGA.initialize(TRACKING_ID);
        // ReactGA.pageview(window.location.pathname);
    }
    collapseToggle=(name)=>{
        this.setState({[name]:!this.state[name]})
    }
    render() {
        const image=[
            {image:Hrbp},
            {image:Ram},
            {image:Corpu},
            {image:Chrpe},
            {image:Cptm},
            {image:Hr},
            {image:Rise},
        ]
        const {collapse_consulting,collapse_learning,collapse_event,collapse_assesment,collapse_digital,collapse_digital_human}=this.state
        return (
            <div style={{backgroundColor:'#FBFBFB'}}>
                <Navbar/>
                <br/><br/><br/><br/>
                <Banner image={image} title="We enhance your Execution Capability" subtitle="We help you transform you organization’s execution capability through Strategy, Process, Structure, People, and Culture"/>

               
                <br/>
                <section className='mobile-services'>
                    <h1>Our Services</h1>
                    <br/>
                    <div className='card-mobile' onClick={()=>this.collapseToggle('collapse_consulting')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={strategy} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Strategy and Organization Services</h1>
                            <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_consulting')} className={collapse_consulting?'chevron':''}/>
                        </div>

                        </div>
                        <Collapse in={collapse_consulting}>
                            {data_consulting.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button>
                                    </div>
                                </div>
                            ))}
                        </Collapse>
                    </div>
                    <br/>
                    <div className='card-mobile' onClick={()=>this.collapseToggle('collapse_learning')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={learning} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Learning</h1>
                             <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_learning')} className={collapse_learning?'chevron':''}/>
                             
                        </div>
                        </div>
                        <Collapse in={collapse_learning}>
                        {data_learning.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button>
                                    </div>
                                </div>
                            ))}     
                        </Collapse>
                    </div>
                    <br/>
                    <div className='card-mobile' onClick={()=>this.collapseToggle('collapse_event')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={insight1} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Event Management</h1>
                             <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_event')} className={collapse_event?'chevron':''}/>
                             
                        </div>
                        </div>
                        <Collapse in={collapse_event}>
                            {data_eventmanagement.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button>
                                    </div>
                                </div>
                            ))}
                        </Collapse>
                    </div>
                    <br/>
                    <div className='card-mobile '  onClick={()=>this.collapseToggle('collapse_assesment')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={assesment} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Assessment Center</h1>
                             <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_assesment')} className={collapse_assesment?'chevron':''}/>
                             
                        </div>
                        </div>
                        <Collapse in={collapse_assesment}>
                        {data_assestment.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button>
                                    </div>
                                </div>
                            ))}    
                        </Collapse>
                    </div>
                    <br/>
                    <div className='card-mobile'  onClick={()=>this.collapseToggle('collapse_digital')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={digital} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Digital Learning</h1>
                             <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_digital')} className={collapse_digital?'chevron':''}/>
                             
                        </div>
                        </div>
                        <Collapse in={collapse_digital}>
                            {data_digitallearning.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button>
                                    </div>
                                </div>
                            ))}
                        </Collapse>
                    </div>
                    <br/>
                    <div className='card-mobile'  onClick={()=>this.collapseToggle('collapse_digital_human')}>
                        <div className='box-card-mobile'>
                        <div className='overlay-services'>
                            <img src={img1} alt="insight"/>
                        </div>
                        <div className='card-services'>
                             <h1>Digital & Human Transformation</h1>
                             <img src={chevron} style={{width:20}}  onClick={()=>this.collapseToggle('collapse_digital_human')} className={collapse_digital_human?'chevron':''}/>
                             
                        </div>
                        </div>
                        <Collapse in={collapse_digital_human}>
                            {data_digital_human.map((data,i)=>(
                                <div key={i}>
                                    <hr/>
                                    <div className='collapse-content'>
                                        <b>{data.title}</b>
                                        <br/><br/>
                                        <p>{data.content}</p>
                                        {/* <Button onClick={()=>window.location.assign(data.link)} color="primary" style={{textTransform:'none',padding:0}} size="small">Read more detail</Button> */}
                                    </div>
                                </div>
                            ))}
                        </Collapse>
                    </div>
                </section>
                <br/><br/>
                <section className='mobile-insight'>
                    <Event jumlah="3"/>
                   
                </section>
                <br/><br/>
                <section className='mobile-insight'>
                <Insight jumlah={4}/>

                    
                </section>
                <br/><br/>
               
                <section className='careers-mobile'>
                    <div style={{padding:30}}>
                        <h1>Join ONE GML</h1>
                        <br/>
                        <p>We seek a broad range of skills—from digital to interpersonal to analytical. Join us to make a lasting impact on our nation, industries, and society.</p>
                        <br/>
                        <Button onClick={()=>window.location.assign('/careers')} style={{textTransform:'none'}} color="primary"
                            endIcon={<img src={Chevron} style={{width:13}}/>}
                        >Careers</Button>
                    </div>
                    <div className='careers-mobile-img'>
                    <img src={join}/>
                    </div>
                </section>
                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                <section className='contacts-mobile'>
                    <div style={{width:'90%',height:'100%',margin:'auto',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <h1>How we can help<br/> your organization?</h1>
                        <Button onClick={()=>window.location.assign('/contact')} style={{textTransform:'none'}} variant="contained" size="small" className="contacts-button-mobile">Contact Us</Button>
                   
                    </div>
                    {/* <Button style={{textTransform:'none'}} variant="contained" size="small" className="contact-button-mobile">Contact Us</Button> */}
                </section>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
